import script from "./StepFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepFile.vue?vue&type=script&setup=true&lang=ts"

import "./StepFile.vue?vue&type=style&index=0&id=6b11aaf8&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b11aaf8"]])

export default __exports__